import { gql, useMutation } from '@apollo/client'

export const CREATE_LABEL = gql`
  mutation($input: LabelInput) {
    createLabel(input: $input) {
      id
    }
  }
`

export const useCreateLabel = () => {
  const [mutate, { data, loading, error }] = useMutation(CREATE_LABEL, {
    update(cache) {
      cache.modify({
        fields: {
          getLabels() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
